import React, { useEffect, useState } from "react";
import "./style.scss";
import axios from "axios";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import CustomFormWrapper from "../../../CoreComponent/CustomFormWrapper";
import { Drawer, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { DataGrid } from "@mui/x-data-grid";

const SpeakerTable = () => {
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const [speakers, setSpeakers] = useState([]);
  const [selectedSpeaker, setSelectedSpeaker] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const { conferenceId } = useParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const openMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  useEffect(() => {
    const fetchSpeakers = async () => {
      try {
        const response = await axios.get(
          `${BaseUrl}/dinner/attendees/${conferenceId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setSpeakers(response.data.data);
        console.log("Speakers Data:", response.data.data);
      } catch (error) {
        console.error("Error fetching speakers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSpeakers();
  }, [token, conferenceId, BaseUrl]);

  const openModal = (speaker) => {
    setSelectedSpeaker(speaker);
    setModalIsOpen(true);
  };

  // ✅ Correct DataGrid columns
  const columns = [
    {
      field: "companion_name",
      headerName: "Companion Name",
      flex: 1,
      minWidth: 230,
      cellClassName: "centered-cell",
    },
    {
      field: "companion_price",
      headerName: "Companion Price",
      flex: 1,
      minWidth: 230,
      cellClassName: "centered-cell",
    },
    {
      field: "companion_Status",
      headerName: "Companion Status",
      flex: 1,
      minWidth: 230,
      cellClassName: "centered-cell",
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.2,
      minWidth: 90,
      cellClassName: "centered-cell",
      renderCell: (params) => (
        <>
          <IconButton onClick={(event) => openMenu(event, params.row)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && selectedRow?.id === params.row.id}
            onClose={closeMenu}
          >
            <MenuItem onClick={() => openModal(params.row)}>View</MenuItem>
          </Menu>
        </>
      ),
    },
  ];

  // ✅ Build rows with companion count logic
  const rows = speakers.map((row, index) => {
    // Count total companions for this speaker_id
    const totalCompanions = speakers.filter(
      (r) => r.speaker?.id === row.speaker?.id
    ).length;

    return {
      id: index + 1,
      conference_id: row.conference_id,
      companion_name: row.companion_name,
      companion_price: row.companion_price,
      companion_Status: row.status,
      dinner_invitation: row.speaker?.dinner_invitation,
      number_of_all_companions: totalCompanions || 0,
      speaker_name: row?.user?.name,
    };
  });

  return (
    <div className="speaker-table">
      <Typography
        variant="h6"
        sx={{
          color: "#c62828",
          fontWeight: "bold",
          fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
          textAlign: "center",
        }}
      >
        Dinner Speakers List
      </Typography>

      {loading ? (
        <div>Loading...</div>
      ) : speakers.length === 0 ? (
        <div>No speakers available</div>
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 8,
              },
            },
          }}
          pageSizeOptions={[8]}
          checkboxSelection
          disableRowSelectionOnClick
          autoHeight
          sx={{
            marginTop: "20px",
            "& .MuiDataGrid-virtualScroller": {
              overflow: "hidden",
            },
          }}
        />
      )}

      {/* ✅ Drawer Modal */}
      <Drawer
        anchor="right"
        sx={{
          zIndex: (theme) => theme.zIndex.modal + 1,
          "& .MuiDrawer-paper": {
            zIndex: (theme) => theme.zIndex.modal + 1,
            width: {
              xs: "100%",
              sm: "50%",
              md: "40%",
              lg: "30%",
              xl: "30%",
            },
          },
        }}
        open={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: 2,
          }}
        >
          <IconButton onClick={() => setModalIsOpen(false)}>
            <CloseRounded />
          </IconButton>
        </div>

        <CustomFormWrapper title="Speaker Details" noActions={true}>
          {selectedSpeaker && (
            <div className="modal-content9">
              <p>
                <strong>Speaker Name:</strong>{" "}
                {selectedSpeaker?.speaker_name || "N/A"}
              </p>

              <p>
                <strong>Companion Name:</strong>{" "}
                {selectedSpeaker?.companion_name || "N/A"}
              </p>

              <p>
                <strong>Companion Price:</strong>{" "}
                {selectedSpeaker?.companion_price
                  ? `$${selectedSpeaker?.companion_price}`
                  : "N/A"}
              </p>
               <p>
                <strong>Companion Status:</strong>{" "}
                {selectedSpeaker?.companion_Status
                  ? `${selectedSpeaker?.companion_Status}`
                  : "N/A"}
              </p>

              <p>
                <strong>Dinner Invitation:</strong>{" "}
                {selectedSpeaker?.dinner_invitation ? "Yes" : "No"}
              </p>
              

              {/* <p>
                <strong>Number of Companions:</strong>{" "}
                {selectedSpeaker?.number_of_all_companions || 0}
              </p> */}
            </div>
          )}
        </CustomFormWrapper>
      </Drawer>
    </div>
  );
};

SpeakerTable.propTypes = {
  speakers: PropTypes.array,
};

export default SpeakerTable;